import request from '@/utils/request'

// ===== 生成作文 =====
export function generateEssay(data) {
    return request({ url: '/education/essay/generate', method: 'post', data })
}

export function previewEssay(id) {
    return request({ url: '/education/essay/preview/' + id, method: 'get' })
}

export function downloadEssay(id) {
    return request({ url: '/education/essay/download/' + id, method: 'get' })
}

// ===== 题目管理 =====
export function reqQuestionPage(params) {
    return request({ url: '/education/essay/question/page', method: 'post', data: params })
}

export function reqQuestionDetail(id) {
    return request({ url: '/education/essay/question/detail/' + id, method: 'get' })
}

export function reqQuestionAdd(data) {
    return request({ url: '/education/essay/question/add', method: 'post', data })
}

export function reqQuestionUpdate(data) {
    return request({ url: '/education/essay/question/update', method: 'post', data })
}

export function reqQuestionDelete(id) {
    return request({ url: '/education/essay/question/delete/' + id, method: 'get' })
}

export function reqQuestionAnalyze(id) {
    return request({ url: '/education/essay/question/analyze/' + id, method: 'post' })
}

// ===== 作文类型 =====
export function reqTypePage(params) {
    return request({ url: '/education/essay/type/page', method: 'post', data: params })
}

export function reqTypeAdd(data) {
    return request({ url: '/education/essay/type/add', method: 'post', data })
}

export function reqTypeUpdate(data) {
    return request({ url: '/education/essay/type/update', method: 'post', data })
}

export function reqTypeDelete(id) {
    return request({ url: '/education/essay/type/delete/' + id, method: 'get' })
}

export function reqTypeList() {
    return request({ url: '/education/essay/type/list', method: 'get' })
}

export function reqTypeSort(ids) {
    return request({ url: '/education/essay/type/sort', method: 'post', data: ids })
}

// ===== 生成记录 =====
export function reqInstancePage(params) {
    return request({ url: '/education/essay/instance/page', method: 'post', data: params })
}

export function reqInstanceDelete(id) {
    return request({ url: '/education/essay/instance/delete/' + id, method: 'get' })
}

// ===== 状态管理 =====
export function reqStartGrading(instanceId) {
    return request({ url: '/education/essay/instance/start-grading', method: 'post', params: { instanceId } })
}

export function reqCompleteGrading(instanceId) {
    return request({ url: '/education/essay/instance/complete-grading', method: 'post', params: { instanceId } })
}

export function reqRollbackGrading(instanceId) {
    return request({ url: '/education/essay/instance/rollback-grading', method: 'post', params: { instanceId } })
}
